import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../images/logo_without_name.png';
import './Header.css';

function Header({ isAuthenticated, onLogout }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-inner">
          <NavLink to="/" className="logo-section" onClick={closeMobileMenu}>
            <img
              src={logo}
              alt="Iswaran Logo"
              className="logo-icon"
            />
            <h2 className="logo-text">ISWARAN</h2>
          </NavLink>

          <nav className="nav">
            <NavLink className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} to="/" onClick={closeMobileMenu} end>Home</NavLink>
            <NavLink className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} to="/services" onClick={closeMobileMenu}>Services</NavLink>

            <NavLink className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} to="/about" onClick={closeMobileMenu}>About Us</NavLink>
            <NavLink className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} to="/contact" onClick={closeMobileMenu}>Contact</NavLink>
          </nav>

          <div className="header-actions">
            <NavLink to="/services" className="btn btn-header" onClick={closeMobileMenu}>Book Now</NavLink>
            {isAuthenticated ? (
              <button className="btn btn-secondary hidden-on-mobile" onClick={onLogout}>Logout</button>
            ) : (
              <NavLink to="/login" className="btn btn-secondary hidden-on-mobile" onClick={closeMobileMenu}>Login</NavLink>
            )}

            <button
              className={`mobile-menu-btn ${isMobileMenuOpen ? 'is-open' : ''}`}
              id="mobileMenuBtn"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span className="material-symbols-outlined menu-icon">
                {isMobileMenuOpen ? 'close' : 'menu'}
              </span>
            </button>
          </div>
        </div>
      </header>

      <div
        className={`mobile-nav ${isMobileMenuOpen ? 'is-open' : ''}`}
        id="mobileNav"
      >
        <div className="mobile-nav-close-btn-container">
          <button
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'is-open' : ''}`}
            id="mobileMenuBtn"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className="material-symbols-outlined menu-icon">
              {isMobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
        <NavLink className="mobile-nav-link" to="/" onClick={closeMobileMenu} end>Home</NavLink>
        <NavLink className="mobile-nav-link" to="/services" onClick={closeMobileMenu}>Services</NavLink>
        

        <NavLink className="mobile-nav-link" to="/about" onClick={closeMobileMenu}>About Us</NavLink>
        <NavLink className="mobile-nav-link" to="/contact" onClick={closeMobileMenu}>Contact</NavLink>
        {isAuthenticated ? (
          <button className="mobile-nav-link" onClick={() => { onLogout(); closeMobileMenu(); }}>Logout</button>
        ) : (
          <NavLink className="mobile-nav-link" to="/login" onClick={closeMobileMenu}>Login</NavLink>
        )}
      </div>
    </>
  );
}

export default Header;
